exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{min-height:0;min-width:0}.box-post-gallery-image .btn-next,.box-post-gallery-image .btn-prev{position:absolute;bottom:-45px;left:0;right:0;margin:0 auto;display:block}.autor,.autor:hover{color:#212529}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b484af2","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/materia.vue
// module id = ohlT
// module chunks = 0